enum FormErrorMessage {
	MUST_BE_EMAIL = 'Must be an email',
	EMAIL_REQUIRED = 'Email is required',
	INCORRECT_EMAIL_PASSWORD = 'Incorrect email / password combination',
}

export default FormErrorMessage;
